<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.buy_online.lieu_d_achat')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <span class="font-bold" v-if="selected">
                    <template v-if="selected == 'shop'">{{$t('form.buy_online.en_magasin')}}</template>
                    <template v-if="selected == 'online'">{{$t('form.buy_online.en_ligne')}}</template>
                </span>
            </template>

            <template v-slot:open>
                <div @click="end('shop')" class="mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded">
                    <div class="flex items-center p-6 no-gutters">
                        <div class="mr-2">
                            <i class="fas fa-shop"></i>
                        </div>
                        <h5 class="text-lg">{{$t('form.buy_online.en_magasin')}}</h5>
                    </div>
                </div>

                <div @click="end('online')" class="mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded">
                    <div class="flex items-center p-6 no-gutters">
                        <div class="mr-2">
                            <i class="fas fa-earth-europe"></i>
                        </div>
                        <h5 class="text-lg">{{$t('form.buy_online.en_ligne')}}</h5>
                    </div>
                </div>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'buy-online',
    extends: FormCardExtension,

    methods: {
        init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.$formTool.blockData(this.$options.name).next
            if (this.selected && this.selected != callbackData) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/BuyOnlineCard.vue